import { ActionType, createStandardAction } from 'typesafe-actions';

import { NotificationItem, NotificationType } from 'types/notification';
import { PagingListParams } from 'types/api';

export interface INotificationState {
  count: number;
  listLoading: boolean;
  list: NotificationItem[];
  totalCount: number;
  maxPage: number;
  viewMode: NotificationType;
  newList: number[];
}

const initialState: INotificationState = {
  count: 0,
  listLoading: false,
  list: [],
  totalCount: 0,
  maxPage: 1,
  viewMode: -1,
  newList: [],
};

export enum actionTypes {
  GET_COUNT = 'GET_COUNT',
  GET_COUNT_SUCCESS = 'GET_COUNT_SUCCESS',

  GET_LIST = 'GET_LIST',
  GET_LIST_SUCCESS = 'GET_LIST_SUCCESS',
  GET_LIST_FAILURE = 'GET_LIST_FAILURE',

  CHANGE_VIEW_MODE = 'CHANGE_VIEW_MODE',

  SET_ALL_VIEWED = 'SET_ALL_VIEWED',
}

export const actions = {
  getCount: createStandardAction(actionTypes.GET_COUNT)(),
  getCountSuccess: createStandardAction(actionTypes.GET_COUNT_SUCCESS)<{
    count: number;
  }>(),

  getList: createStandardAction(actionTypes.GET_LIST)<PagingListParams>(),
  getListSuccess: createStandardAction(actionTypes.GET_LIST_SUCCESS)<{
    list: NotificationItem[];
    totalCount: number;
    maxPage: number;
    newList: number[];
  }>(),
  getListFailure: createStandardAction(actionTypes.GET_LIST_FAILURE)(),

  changeViewMode: createStandardAction(actionTypes.CHANGE_VIEW_MODE)<
    NotificationType
  >(),

  setAllViewed: createStandardAction(actionTypes.SET_ALL_VIEWED)(),
};

type ActionTypes = ActionType<typeof actions>;

const reducer = (
  state: INotificationState = initialState,
  action: ActionTypes
): INotificationState => {
  switch (action.type) {
    case actionTypes.GET_COUNT_SUCCESS:
      return {
        ...state,
        count: action.payload.count,
      };
    case actionTypes.GET_LIST:
      return {
        ...state,
        listLoading: true,
      };
    case actionTypes.GET_LIST_SUCCESS:
      return {
        ...state,
        list: action.payload.list,
        totalCount: action.payload.totalCount,
        maxPage: action.payload.maxPage,
        listLoading: false,
        newList: action.payload.newList,
      };
    case actionTypes.GET_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
      };
    case actionTypes.CHANGE_VIEW_MODE:
      return {
        ...state,
        viewMode: action.payload,
      };
    case actionTypes.SET_ALL_VIEWED:
      return {
        ...state,
        count: 0,
        newList: [],
      };

    default:
      return state;
  }
};

export default reducer;
